module.exports = __webpack_public_path__ + "img/china.b55d4e6d.jpg";